import { render, staticRenderFns } from "./DevicetypesCreate.vue?vue&type=template&id=5f5e99cf&"
import script from "./DevicetypesCreate.vue?vue&type=script&lang=js&"
export * from "./DevicetypesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports